(()=>{
  const root=()=>window.Shopify?.routes?.root||'/';
  const fmt=(cents,currency)=>{
    try{return new Intl.NumberFormat('en-US',{style:'currency',currency:currency||'USD'}).format((Number(cents)||0)/100)}
    catch(e){return '$'+((Number(cents)||0)/100).toFixed(2)}
  };
  let timer=0,working=false;
  async function fix(){
    if(working)return;
    const drawer=document.getElementById('DCD');
    if(!drawer||drawer.hidden||!drawer.classList.contains('on'))return;
    working=true;
    try{
      const res=await fetch(root()+'cart.js?_dcp='+Date.now(),{
        headers:{Accept:'application/json'},
        credentials:'same-origin',
        cache:'no-store'
      });
      if(!res.ok)return;
      const cart=await res.json();
      const items=cart.items||[];
      const rows=[...drawer.querySelectorAll('.dcd-line')];
      if(!items.length||rows.length!==items.length)return;

      const saleSubtotal=items.reduce((sum,item)=>sum+Number(item.final_line_price??item.line_price??0),0);
      const cartTotal=Number(cart.total_price||0);
      const bundleDiscount=Math.max(0,saleSubtotal-cartTotal);
      const hasBundle=bundleDiscount>0&&saleSubtotal>0;

      let remaining=cartTotal;
      rows.forEach((row,index)=>{
        const item=items[index];
        const base=Number(item.final_line_price??item.line_price??0);
        let effective=base;
        if(hasBundle){
          effective=index===rows.length-1
            ? remaining
            : Math.round(base*cartTotal/saleSubtotal);
          remaining-=effective;
        }

        const price=row.querySelector('.dcd-price');
        if(!price)return;
        price.textContent=fmt(effective,cart.currency);
        if(hasBundle&&base>effective){
          const old=document.createElement('s');
          old.className='dcd-old';
          old.textContent=fmt(base,cart.currency);
          price.appendChild(old);
        }
      });

      const total=drawer.querySelector('[data-total]');
      if(total)total.textContent=fmt(cartTotal,cart.currency);

      const oldTotal=drawer.querySelector('[data-old]');
      if(oldTotal){
        oldTotal.hidden=!hasBundle;
        oldTotal.textContent=hasBundle?fmt(saleSubtotal,cart.currency):'';
      }

      const saveRow=drawer.querySelector('[data-save-row]');
      const save=drawer.querySelector('[data-save]');
      if(saveRow)saveRow.hidden=!hasBundle;
      if(save)save.textContent=hasBundle?'-'+fmt(bundleDiscount,cart.currency):'';

      const checkout=drawer.querySelector('[data-checkout]');
      if(checkout&&items.length)checkout.textContent=fmt(cartTotal,cart.currency)+' — Checkout Securely';
    }catch(e){}finally{
      working=false;
    }
  }

  function schedule(delay=40){
    clearTimeout(timer);
    timer=setTimeout(fix,delay);
  }

  function init(){
    const obs=new MutationObserver(muts=>{
      if(muts.some(m=>{
        const t=m.target?.nodeType===1?m.target:m.target?.parentElement;
        return t?.closest?.('#DCD');
      })) schedule(20);
    });
    obs.observe(document.documentElement,{subtree:true,childList:true,characterData:true});

    document.addEventListener('click',e=>{
      if(e.target.closest('.deko-cart-link,[data-deko-cart-open],[data-q],[data-del],[data-add],#DekoConversionProductForm button')) {
        setTimeout(()=>schedule(10),120);
        setTimeout(()=>schedule(10),350);
      }
    },true);

    document.addEventListener('submit',e=>{
      if(e.target.closest('#DekoConversionProductForm,form[action*="/cart/add"]')){
        setTimeout(()=>schedule(10),160);
        setTimeout(()=>schedule(10),400);
      }
    },true);

    window.addEventListener('pageshow',()=>schedule(50));
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();